const REQUEST_ROUTES = Object.freeze({
	requestRoot: {
		name: 'RequestRoot',
		path: '/requests',
		meta: {
			layout: 'Default',
		},
		redirect: {
			name: 'Request',
		},
		component: () => import('@/presentation/modules/request/views/RootView.vue'),
	},
	request: {
		name: 'Request',
		path: '',
		component: () => import('@/presentation/modules/request/views/RequestIndexView.vue'),
		meta: {
			requiresAuth: true,
		},
	},
});

export default REQUEST_ROUTES;
